var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-content",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "grey lighten-4",
                  attrs: { xs12: "", sm8: "", md4: "" },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "elevation-12" },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", flat: "" } },
                        [_c("v-toolbar-title", [_vm._v("Login")])],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "data-test": "login-username-field",
                              outlined: "",
                              "prepend-icon": "mdi-account",
                              name: "Username",
                              label: "Username",
                              placeholder: "Inserisci qui il nome utente",
                            },
                            model: {
                              value: _vm.username,
                              callback: function ($$v) {
                                _vm.username = $$v
                              },
                              expression: "username",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              "data-test": "login-password-field",
                              outlined: "",
                              "prepend-icon": "mdi-lock",
                              name: "Password",
                              label: "Password",
                              placeholder: "Inserisci qui la password",
                              type: "password",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.login.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { margin: "10px" },
                              attrs: {
                                "data-test": "login-button",
                                primary: "",
                                loading: _vm.loading,
                              },
                              on: { click: _vm.login },
                            },
                            [_vm._v("Accedi")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }